// @ts-ignore
import isPersonnumer from 'is-personnummer';

export function required(value: string | boolean, message: string) {
  return value ? undefined : message;
}

export function alphanumeric(value: string, message: string) {
  const condition = /^([^0-9])+$/;
  return (value && !condition.test(value) ? message : undefined);
}

export function minLength(value: string, min: number, message: string) {
  return ((typeof value === 'string' && value !== '' && value.length < min) ? message : undefined);
}

export function maxLength(value: string, max: number, message: string) {
  return ((typeof value === 'string' && value !== '' && value.length > max) ? message : undefined);
}

export function minValue(value: number, min: number, message: string) {
  return ((value && value !== undefined && value < min) ? message : undefined);
}

export function maxValue(value: number, max: number, message: string) {
  return ((value && value !== undefined && value > max) ? message : undefined);
}

export function number(value: string, message: string) {
  const condition = /^(\d)+$/;
  return (!condition.test(value) && value !== '' ? message : undefined);
}

export function email(value: string, message: string) {
  const condition = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return (value && !condition.test(value) && value !== '' ? message : undefined);
}

export function phone(value: any, message: string) {
  const condition = /^[^a-zA-Z]+$/;
  return (value && !condition.test(value) && value !== '' ? message : undefined);
}

export function personnummer(value: any, message: string) {
  return (isPersonnumer(value) && value !== '' ? undefined : message);
}

/* export const getValidations = (validators: any, isRequired: boolean, requiredMessage: string) => {
  return isRequired ? [...validators, required(requiredMessage)] : validators;
}; */



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/validators.ts